'use client';

import React from 'react';
import LandingNav from './components/LandingNav';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import HowItWorks from './components/HowItWorks';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import LandingFooter from './components/LandingFooter';

export default function LandingPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background)' }}>
      <LandingNav />
      <HeroSection />
      <StatsBar />
      <HowItWorks />
      <TestimonialsSection />
      <PricingSection />
      <LandingFooter />
    </div>
  );
}